const BEHAVIOUR_EVIDENCE = {

  thinking: {
    high: "approach problems thoughtfully and make decisions using logic and evidence",
    moderate: "usually think carefully before making decisions",
    low: "often prefer practical action before lengthy analysis"
  },

  control: {
    high: "plan and organise your work before getting started",
    moderate: "generally work in an organised and consistent way",
    low: "prefer a more flexible approach to completing tasks"
  },

  inclusion: {
    high: "actively contribute during discussions and group activities",
    moderate: "to be comfortable working with others when needed",
    low: "often prefer contributing independently"
  },

  affection: {
    high: "build positive working relationships with others",
    moderate: "communicate respectfully with people around you",
    low: "tend to focus more on completing tasks than building relationships"
  },

  flexibility: {
    high: "adapt confidently when situations change",
    moderate: "adjust to new situations with a little time",
    low: "prefer familiar routines and predictable situations"
  }

};

function getBehaviourLevel(score) {

  if (score >= 80) return "high";

  if (score >= 55) return "moderate";

  return "low";

}

function buildObservation(applicant) {

  const behaviours = Object.entries({
    thinking: applicant.thinking,
    control: applicant.control,
    inclusion: applicant.inclusion,
    affection: applicant.affection,
    flexibility: applicant.flexibility
  })

    .sort((a, b) => b[1] - a[1])

    .slice(0, 3)

    .map(([dimension, score]) => {

      const level =
        getBehaviourLevel(score);

      return BEHAVIOUR_EVIDENCE[dimension][level];

    });

  return (
    `From your assessment responses, you tend to ` +
    `${behaviours[0]}, ${behaviours[1]}, and ${behaviours[2]}.`
  );

}

function interpretApplicant(applicant) {

  const rankedBehaviours = Object.entries({
    thinking: applicant.thinking,
    control: applicant.control,
    inclusion: applicant.inclusion,
    affection: applicant.affection,
    flexibility: applicant.flexibility
  })

    .sort((a, b) => b[1] - a[1]);

  const strongestDimensions =
    rankedBehaviours.slice(0, 3);

  const weakestDimensions =
    rankedBehaviours.slice(-2);

  return {

    observation:
    buildObservation(applicant),

    decisionStyle:
    applicant.thinking >= 80
        ? "You naturally prefer making decisions based on careful analysis, logic and evidence."
        : applicant.thinking >= 55
        ? "You generally think carefully before making decisions while remaining open to practical considerations."
        : "You often prefer practical action and learning through experience rather than extended analysis.",

    workingStyle:
    applicant.control >= 80
        ? "You usually like planning, organising and working towards clear objectives."
        : applicant.control >= 55
        ? "You generally work in an organised way while remaining reasonably adaptable."
        : "You tend to prefer flexibility and adjusting your approach as situations develop.",

    interactionStyle:
    applicant.inclusion >= 80
        ? "You are naturally comfortable participating in discussions and collaborative activities."
        : applicant.inclusion >= 55
        ? "You are generally comfortable contributing when collaboration is required."
        : "You often prefer contributing independently before engaging with others.",

    adaptability:
    applicant.flexibility >= 80
        ? "You adapt confidently when priorities or situations change."
        : applicant.flexibility >= 55
        ? "You can adjust to change after having some time to adapt."
        : "You generally perform best in predictable environments with clear expectations.",

    strongestDimensions,

    weakestDimensions,

   behaviourProfile:

    rankedBehaviours.map(

        ([dimension, score]) => ({

        dimension,

        score,

        level:
            getBehaviourLevel(score),

        evidence:
            BEHAVIOUR_EVIDENCE[
            dimension
            ][
            getBehaviourLevel(score)
            ]

        })

    ),

    dominantBehaviours:

    strongestDimensions.map(

        ([dimension, score]) => ({

        dimension,

        score,

        level:
            getBehaviourLevel(score),

        evidence:
            BEHAVIOUR_EVIDENCE[
            dimension
            ][
            getBehaviourLevel(score)
            ]

        })

    )

    };

    }

export {
  BEHAVIOUR_EVIDENCE,
  getBehaviourLevel,
  buildObservation,
  interpretApplicant
};